import React, { useEffect, useState } from 'react';
import * as _ from 'lodash';
import styles from '../shared/ProgressReport.module.scss';
import { Checkbox } from '@mui/material';
import NoData from '../../assets/NoData/NoData';
import { Spinner } from 'react-bootstrap';
import { Pagination } from '../../assets/Pagination/Pagination';
import moment from 'moment';

const ScientificWork = ({
    facultyList,
    fetchFacultyList,
    fetchYear,
    scientificWorkYear,
    fetchTypeof,
    scientificWorkTypeof,
    fetchList,
    scientificWorkList,
    isError,
    isLoading,
    pagesCount,
    fetchDivisions,
    divisions,

    ...props
}) => {

    const [checked, setChecked] = useState(false);
    const [time, setTime] = useState(true)

    const [state, setState] = useState({
        faculty: 0,
        orderdate: 0,
        from_date: 0,
        to_date: 0,
        ordertypes: 0,
        orderstate: 1,
        ordernum: 0,
        numberPage: 0,
        by_user: checked,
    });

    function handleChange() {
        setChecked(!checked);
        setState({ ...state, by_user: !checked });
    }

    useEffect(() => {
        fetchFacultyList()
        fetchDivisions()
        fetchYear()
        fetchTypeof()
        // fetchList(state)

    }, [])

    useEffect(() => {
        fetchList(state)
    }, [state.numberPage])

    useEffect(() => {
        state.orderdate || state.numberPage &&
            loadList()
    }, [state.orderdate, state.numberPage])


    const loadList = () => {
        fetchList(state)
    }

    const handleSelectorChange = (e) => {
        const { name, value } = e.target
        setState({ ...state, [name]: value })
    };

    useEffect(() => {
        setState({ ...state, numberPage: 0 })
    }, [
        state.faculty,
        state.orderdate,
        state.ordertypes,
        state.orderstate,
        state.ordernum,

        state.from_date,
        state.to_date
    ])

    // order_type as "Вид работы", 
    // ordernum as "Номер", 
    // COALESCE(xp_get_order_target(idorder),'Общеакадемический') as "Подразделения", 
    // orderdate as "Дата", 
    // order_state as "Статус", 
    // ord_close_date "Дата закрытия", 
    // CASE WHEN ord_init_mid IS NOT NULL THEN xp_f_get_mid_fio(ord_init_mid, 1)  ELSE string_agg(fio ,',' ORDER BY fio) END  as "Исполнитель", 
    // nir_instructor_id as "Научный руководитель", 
    // nir_subinstructor_id as "Заместитель научного руководителя", 
    // nir_main_executor as "Ответственный исполнитель", 
    // ord_content as "Содержание"


    const renderEducationProgramsTable = (plan, index) => (
        <tr key={index} className="pointer">
            {/* <td>{plan["Вид работы"]}</td>
          <td>{plan["Номер"]}</td>
          <td>{plan["Подразделения"]}</td>
          <td>{plan["Дата"] ? moment(plan["Дата"]).format('DD.MM.YYYY') : ''}</td>
          <td>{plan["Статус"]}</td>
          <td>{plan["Исполнитель"]}</td>
          <td>{plan["Научный руководитель"]}</td>
          <td>{plan["Заместитель научного руководителя"]}</td>
          <td>{plan["Ответственный исполнитель"]}</td>
          <td>{plan["Содержание"]}</td> */}

            <td>{plan["order_type"]}</td>
            <td>{plan["ordernum"]}</td>
            <td>{plan["COALESCE"]}</td>
            <td>{plan["orderdate"] ? moment(plan["orderdate"]).format('DD.MM.YYYY') : ''}</td>
            <td>{plan["order_state"]}</td>
            <td>{plan["executor"]}</td>
            <td>{plan["nir_instructor_id"]}</td>
            <td>{plan["nir_subinstructor_id"]}</td>
            <td>{plan["nir_main_executor"]}</td>
            <td style={{ wordBreak: 'break-all' }}>{plan["ord_content"]}</td>
        </tr>
    );

    const setToggleTime = (data) => {
        if (data == 'period') {
            setTime(false)
        } else {
            setTime(true)
            setState((prev) => ({ ...prev, from_date: 0, to_date: 0 }))
        }
    }

    return (
        <div className="27jpg">
            <div className="captions">Научно-исследовательские работы</div>

            <div className={styles.selectors}>

                <div className={styles.selectorsRight}>
                    {time === true &&
                        <div>
                            <label>
                                Год:
                            </label>
                            <select
                                name='orderdate'
                                onChange={handleSelectorChange}
                                style={{ width: "55%" }}
                            >
                                <option value='0'>Все</option>
                                {scientificWorkYear && scientificWorkYear.map(c => (<option key={c.idorderdate} value={c.idorderdate}>
                                    {c.ordd}
                                </option>))
                                }
                            </select>
                            <button style={{ marginBottom: "0px" }} className={styles.updateButton} onClick={() => setToggleTime('period')}>Период</button>
                        </div>
                    }
                    {time === false &&
                        <div style={{ height: "46px" }}>
                            <label>
                                Период:
                            </label>
                            <span style={{ paddingRight: "5px" }}> C </span>

                            <input
                                // name='orderdate_from'
                                name='from_date'
                                type="date"
                                value={moment().subtract(1, 'month').format('YYYY-MM-DD')}
                                onChange={handleSelectorChange}
                                style={{ width: "150px", textAlign: 'center' }}
                            >
                            </input>
                            <span style={{ padding: "5px" }}>До</span>
                            <input
                                // name='orderdate_to'
                                name='to_date'
                                type="date"
                                value={state.to_date || moment().format('YYYY-MM-DD')}
                                onChange={handleSelectorChange}
                                style={{ width: "150px", textAlign: 'center' }}
                            >
                            </input>
                            <button style={{ marginBottom: "0px" }} className={styles.updateButton} onClick={() => setToggleTime('year')}>Год</button>
                        </div>

                    }

                    <div>
                        <label>
                            Статус:
                        </label>
                        <select
                            name='orderstate'
                            onChange={handleSelectorChange}
                        >
                            {/* <option value="1" disabled selected>действующий</option> */}
                            <option value="1" >действующий</option>
                            <option value='0'>Все</option>
                            <option value="2" >закрыт</option>

                        </select>
                    </div>
                    <div>
                        <label>
                            Номер:
                        </label>
                        <input
                            name='ordernum'
                            onChange={handleSelectorChange}
                        />

                    </div>
                </div>


                <div className={styles.selectorsLeft}>
                    <div>
                        <label>
                            Подразделение:
                        </label>
                        <select
                            name='faculty'
                            onChange={handleSelectorChange}
                        // value={facultyVse}
                        >
                            <option value='0'>Все</option>
                            {divisions && divisions.map(f => (
                                <option key={f.did} value={f.did}>
                                    {f.name}
                                </option>))
                            }
                        </select>
                    </div>
                    <div>
                        <label>
                            Вид работы:
                        </label>
                        <select
                            name='ordertypes'
                            onChange={handleSelectorChange}
                        >
                            <option value='0'>Все</option>
                            {scientificWorkTypeof && scientificWorkTypeof.map(c => (<option key={c.order_type_id} value={c.order_type_id}>
                                {c.order_type}
                            </option>))
                            }
                        </select>
                    </div>
                    <div>
                        <label>C моим участием</label>
                        <Checkbox type="checkbox" checked={checked} onChange={handleChange} />
                    </div>


                </div>

            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <button className={styles.updateButton} onClick={loadList}>Обновить</button>
            </div>
            {isLoading ? (
                <div className="text-center">
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                </div>
            ) : (
                isError ?
                    <NoData text='Данные отсутствуют' /> : scientificWorkList.length != 0 ?
                        <>
                            <Pagination
                                pageCount={pagesCount}
                                numberPage={state.numberPage}
                                onPageChange={(page) => setState({ ...state, numberPage: page.selected })}
                            />
                            <br />
                            <div style={{
                                width: "90vw",
                                overflow: 'auto',
                                position: "relative",
                                marginLeft: "calc(-45vw + 510px)"
                            }}>
                                <table className="umkT-table ">

                                    <thead>
                                        <tr>
                                            <th>Вид работы</th>
                                            <th>Номер</th>
                                            <th>Подразделения</th>
                                            <th>Дата</th>
                                            <th>Статус</th>
                                            <th>Исполнитель</th>
                                            <th>Научный руководитель</th>
                                            <th>Заместитель научного руководителя</th>
                                            <th>Ответственный исполнитель</th>
                                            <th>Содержание</th>
                                        </tr>
                                    </thead>
                                    <tbody >
                                        {scientificWorkList.map(renderEducationProgramsTable)}
                                    </tbody>
                                </table>
                            </div>
                            <Pagination
                                pageCount={pagesCount}
                                numberPage={state.numberPage}
                                onPageChange={(page) => setState({ ...state, numberPage: page.selected })}
                            />
                        </>
                        : <NoData text='Выберите фильтры или нажмите обновить ' />

            )}


        </div>
    );
}


export default ScientificWork;
